export function waLink(settings, message) {
  let num = String(settings?.wa_number || "").replace(/\D/g, "");
  if (!num) return null;
  if (num.startsWith("0")) num = "62" + num.slice(1);
  return `https://wa.me/${num}?text=${encodeURIComponent(message)}`;
}

export function armadaMessage(a) {
  const nama = a?.nama || "[ Nama Truck ]";
  return `Halo Putra Bengawan Logistik, saya ingin menanyakan ketersediaan truck *${nama}* / Unit *${a?.unit || "-"}* untuk kebutuhan pengiriman barang saya.`;
}

export function generalMessage() {
  return "Halo Putra Bengawan Logistik, saya ingin berkonsultasi mengenai layanan logistik dan pengiriman barang untuk kebutuhan bisnis saya.";
}

export function waNumberDisplay(settings) {
  return settings?.wa_number ? settings.wa_number : "[ Nomor WhatsApp ]";
}
